import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

const SnackbarContext = createContext(null);

export function SnackbarProvider({ children }) {
  const [notification, setNotification] = useState({
    id: 0,
    open: false,
    message: '',
    severity: 'success',
  });

  const showSnackbar = useCallback((message, severity = 'success') => {
    setNotification(previous => ({ id: previous.id + 1, open: true, message, severity }));
  }, []);

  const closeSnackbar = useCallback((event, reason) => {
    if (reason === 'clickaway') return;
    setNotification(previous => ({ ...previous, open: false }));
  }, []);

  const context = useMemo(() => ({ showSnackbar, closeSnackbar }), [showSnackbar, closeSnackbar]);
  const autoHideDuration = ['warning', 'error'].includes(notification.severity) ? 10000 : 6000;

  return (
    <SnackbarContext.Provider value={context}>
      {children}
      <Snackbar
        key={notification.id}
        open={notification.open}
        autoHideDuration={autoHideDuration}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          severity={notification.severity}
          elevation={6}
          variant="filled"
          onClose={closeSnackbar}
          closeText="Cerrar notificación"
          style={{ maxWidth: 560, width: '100%', boxSizing: 'border-box', overflowWrap: 'anywhere' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

export default function useSnackbar() {
  const context = useContext(SnackbarContext);
  if (!context) throw new Error('useSnackbar debe usarse dentro de SnackbarProvider.');
  return context;
}
